module.exports = __webpack_public_path__ + "img/404.9ecb60e6.jpg";